(function () {
  "use strict";

  var SELECTOR = ".cat-hero";

  function CategoryHero(root) {
    this.root = root;

    if (root.classList.contains("cat-hero--overlap")) {
      document.body.classList.add("ch-has-overlap-hero");
      tagOverlapWrapper(root);
    }

    this.measure = this.measure.bind(this);
    this.measure();
    this.bindMeasure();
    this.bindAnchorButtons();
  }

  /* Hero buttons whose link is an in-page anchor (e.g. "#our-story"):
     smooth-scroll to the target instead of doing a hash navigation that
     the page-transition layer turns into a reload. Falls back to the first
     section after the hero when the id isn't on the page. */
  CategoryHero.prototype.bindAnchorButtons = function () {
    var self = this;
    var links = this.root.querySelectorAll('a[href^="#"], a[href*="#"]');

    Array.prototype.forEach.call(links, function (link) {
      var raw = link.getAttribute("href") || "";
      var hash = raw.indexOf("#") !== -1 ? raw.slice(raw.indexOf("#") + 1) : "";
      if (!hash) return;

      link.addEventListener("click", function (e) {
        e.preventDefault();

        var target = document.getElementById(hash);
        if (!target) {
          // fall back to the section wrapper right after this hero
          var wrapper = self.root.closest(".shopify-section") || self.root;
          target = wrapper.nextElementSibling;
        }
        if (!target) return;

        var header = document.querySelector(".custom-header");
        var offset = header ? header.offsetHeight + 12 : 12;
        var y =
          target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: Math.max(0, y),
          behavior: "smooth",
        });

        if (history.replaceState) {
          history.replaceState(null, "", "#" + hash);
        }
      });
    });
  };

  /* Tag the section wrapper (the child of #MainContent) so the
     stylesheet can pull it up under the header — regardless of
     template type or how deep Shopify nests the wrapper. */
  function tagOverlapWrapper(el) {
    var main =
      document.getElementById("MainContent") || document.querySelector("main");
    var node = el.closest(".shopify-section") || el;
    if (main) {
      while (node.parentElement && node.parentElement !== main) {
        node = node.parentElement;
      }
    }
    if (!main || node.parentElement === main) {
      node.classList.add("ch-overlap-section");
    }
  }

  CategoryHero.prototype.measure = function () {
    var header = document.querySelector(".custom-header");
    var headerHeight = header ? header.offsetHeight : 0;

    this.root.style.setProperty("--cat-hero-header-h", headerHeight + "px");
    document.body.style.setProperty("--ch-overlap-h", headerHeight + "px");

    // Read AFTER the header var lands, so the negative overlap margin is
    // already applied and this is the hero's true distance from the top.
    var top = this.root.getBoundingClientRect().top + window.pageYOffset;
    this.root.style.setProperty(
      "--cat-hero-top-offset",
      Math.max(0, Math.round(top)) + "px"
    );
  };

  CategoryHero.prototype.bindMeasure = function () {
    var self = this;
    var pending = false;

    function remeasure() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        self.measure();
      });
    }

    window.addEventListener("resize", remeasure);
    window.addEventListener("orientationchange", remeasure);
    window.addEventListener("load", remeasure);

    // Header height can change after first paint (logo image finishes
    // loading, announcement bar dismissed), so watch it directly.
    if (window.ResizeObserver) {
      var header = document.querySelector(".custom-header");
      if (header) new ResizeObserver(remeasure).observe(header);

      var group = document.getElementById("header-group");
      if (group) new ResizeObserver(remeasure).observe(group);
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.catHeroReady === "true") return;
      root.dataset.catHeroReady = "true";
      new CategoryHero(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor — re-init / re-measure when a section is re-rendered
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:select", function (event) {
    init(event.target);
  });
})();
